module.exports = __webpack_public_path__ + "static/1-e518572f9eebc2c080e8546e439f2222.png";